document.addEventListener('DOMContentLoaded', function () {
  /* ================================================================
     NOTE ON SCOPE: everything in this file that touches
     --pj-header-bottom exists SOLELY to keep main.pj-main--offset's
     padding-top correct (so page content never renders underneath
     the fixed header). It no longer has anything to do with the mega
     menu — the mega menu is positioned with pure CSS now
     (position:absolute; top:100% in assets/theme.css), so it can
     never go stale regardless of header height, font loading,
     transitions, or viewport width. Nothing below needs to change if
     the mega menu is ever modified again.
     ================================================================ */

  /* Position the fixed header right under the fixed announcement bar */
  var announcement = document.querySelector('.pj-announcement');
  var setAnnouncementHeight = function () {
    var h = announcement ? announcement.offsetHeight : 0;
    document.documentElement.style.setProperty('--announcement-h', h + 'px');
  };
  setAnnouncementHeight();
  window.addEventListener('resize', setAnnouncementHeight);

  /* Header: transparent -> solid on scroll (homepage only).
     On any page that already has the server-rendered
     "pj-header--solid" class (i.e. every page except the
     homepage), the header must ALWAYS stay solid, regardless of
     scroll position — otherwise a fresh page load at scrollY 0
     strips the solid background, leaving white header text/icons
     (including the Book An Appointment button) unreadable against
     a plain light page. */
  var header = document.querySelector('[data-pj-header]');
  var isForceSolid = header ? header.classList.contains('pj-header--solid') : false;

  /* Used ONLY for main.pj-main--offset's padding-top. Not read by
     the mega menu anywhere in theme.css. */
  var setHeaderBottom = function () {
    if (!header) return;
    var rect = header.getBoundingClientRect();
    document.documentElement.style.setProperty('--pj-header-bottom', rect.bottom + 'px');
  };

  if (header) {
    var threshold = 24;
    var setState = function () {
      if (isForceSolid || window.scrollY > threshold) {
        header.classList.add('is-solid');
      } else {
        header.classList.remove('is-solid');
      }
      setHeaderBottom();
    };
    setState();
    window.addEventListener('scroll', setState, { passive: true });
    window.addEventListener('resize', setHeaderBottom);

    if ('ResizeObserver' in window) {
      var headerRO = new ResizeObserver(function () {
        setHeaderBottom();
      });
      headerRO.observe(header);
    }

    header.addEventListener('transitionend', function (e) {
      if (e.target !== header) return;
      if (e.propertyName === 'top' || e.propertyName === 'padding' || e.propertyName === 'padding-top' || e.propertyName === 'padding-bottom') {
        setHeaderBottom();
      }
    });
  }

  if (announcement && 'ResizeObserver' in window) {
    var announcementRO = new ResizeObserver(function () {
      setAnnouncementHeight();
      if (header) setHeaderBottom();
    });
    announcementRO.observe(announcement);
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      setAnnouncementHeight();
      if (header) setHeaderBottom();
    });
  }

  /* Mobile nav drawer: open/close + screen navigation (Main <-> Shop
     screens). The screen-sliding itself is done by translating
     [data-pj-mobile-track] by -100% per screen index — this works
     for any number of sub-screens (one per mega-menu-linked nav
     item), not just one, since it's index-based rather than
     hardcoded to a fixed count. */
  var menuToggle = document.querySelector('[data-pj-menu-open]');
  var menuClose = document.querySelectorAll('[data-pj-menu-close]');
  var mobileNav = document.querySelector('[data-pj-mobile-nav]');
  var mobileTrack = document.querySelector('[data-pj-mobile-track]');
  var mobileScreens = mobileNav ? Array.prototype.slice.call(mobileNav.querySelectorAll('[data-pj-mobile-screen]')) : [];

  function goToMobileScreen(name) {
    if (!mobileTrack || !mobileScreens.length) return;
    var index = mobileScreens.findIndex(function (screen) {
      return screen.getAttribute('data-pj-mobile-screen') === name;
    });
    if (index < 0) index = 0;
    mobileTrack.style.transform = 'translateX(-' + (index * 100) + '%)';
  }

  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      mobileNav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }

  menuClose.forEach(function (btn) {
    btn.addEventListener('click', function () {
      mobileNav.classList.remove('is-open');
      document.body.style.overflow = '';
      /* Always reset to the main screen so the drawer starts fresh
         next time it's opened, regardless of which screen was open
         when it was closed. */
      goToMobileScreen('main');
    });
  });

  if (mobileNav) {
    mobileNav.querySelectorAll('[data-pj-mobile-open-screen]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        goToMobileScreen(btn.getAttribute('data-pj-mobile-open-screen'));
      });
    });

    mobileNav.querySelectorAll('[data-pj-mobile-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        goToMobileScreen('main');
      });
    });
  }

  /* Scroll reveal */
  var revealEls = document.querySelectorAll('.pj-reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Spotlight carousel: simple drag-to-scroll (touch/trackpad swipe works natively) */
  document.querySelectorAll('[data-pj-spotlight]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-pj-spotlight-track]');
    if (!track) return;

    var isDown = false;
    var startX = 0;
    var startScroll = 0;
    track.addEventListener('mousedown', function (e) {
      isDown = true;
      startX = e.pageX;
      startScroll = track.scrollLeft;
      track.style.scrollBehavior = 'auto';
    });
    window.addEventListener('mouseup', function () {
      isDown = false;
      track.style.scrollBehavior = 'smooth';
    });
    window.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      track.scrollLeft = startScroll - (e.pageX - startX);
    });
  });

  /* Mega menu: keyboard support (mouse/focus-within hover is pure CSS) */
  var nav = document.querySelector('[data-pj-nav]');
  if (nav) {
    var megaTriggers = Array.prototype.slice.call(nav.querySelectorAll('[data-pj-mega-trigger]'));

    // Escape closes an open mega menu by moving focus back to its trigger link
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var openTrigger = megaTriggers.find(function (li) {
        return li.matches(':focus-within') || li.querySelector('.pj-megamenu.is-open');
      });
      if (openTrigger) {
        var link = openTrigger.querySelector('a');
        if (link) link.blur();
        var panel = openTrigger.querySelector('.pj-megamenu');
        if (panel) panel.classList.remove('is-open');
        if (link) link.focus();
      }
    });

    // Left/Right arrow keys move between top-level nav triggers
    var topLevelLinks = Array.prototype.slice.call(nav.querySelectorAll(':scope > .pj-nav__list > .pj-nav__item > a'));
    topLevelLinks.forEach(function (link, index) {
      link.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' && topLevelLinks[index + 1]) {
          e.preventDefault();
          topLevelLinks[index + 1].focus();
        } else if (e.key === 'ArrowLeft' && topLevelLinks[index - 1]) {
          e.preventDefault();
          topLevelLinks[index - 1].focus();
        }
      });
    });
  }

  /* Accordion toggle — used both by the mobile Shop screen's
     Couture/Ready to Wear groups AND their nested Occasion/
     Category/Collection sub-groups. Generic by design: it just
     toggles whatever [data-pj-accordion-panel] immediately follows
     the clicked toggle, so it works at any nesting depth without
     changes. */
  document.querySelectorAll('[data-pj-accordion-toggle]').forEach(function (toggle) {
    var panel = toggle.nextElementSibling;
    toggle.addEventListener('click', function () {
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isOpen));
      if (panel) panel.setAttribute('data-open', String(!isOpen));
    });
  });

  /* Autoplay muted background video where present (Shopify video tag) */
  document.querySelectorAll('[data-pj-autoplay-video] video').forEach(function (video) {
    video.muted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.loop = true;
    video.autoplay = true;
    video.play().catch(function () {});
  });
});
